import type { MouseEventHandler } from "react";

import type { SxProps } from "@mui/material";
import { styled } from "@mui/material";

import type { IconDefinition, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TFontAwesomeProperties = {
  "--fa-primary-color"?: string;
  "--fa-secondary-color"?: string;
};

type FontAwesomeIconClass = "chipIcon" | "root";

const PREFIX = "FontAwesomeIcon";
const classes: Record<FontAwesomeIconClass, string> = {
  root: `${PREFIX}-root`,
  chipIcon: `${PREFIX}-chipIcon`,
};
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)(() => [
  {
    [`&.${classes.root}`]: {},
    [`&.${classes.chipIcon}`]: {
      marginLeft: "9px",
      marginRight: "-6px",
    },
  },
]);

export interface IconProps {
  clickable?: boolean;
  color?: string;
  onClick?: MouseEventHandler;
  opacity?: number;
  name: IconDefinition;
  rotation?: number;
  size?: SizeProp;
  spin?: boolean;
  style?: SxProps & TFontAwesomeProperties;
  className?: FontAwesomeIconClass;
}

const Icon = ({
  clickable = false,
  color,
  onClick,
  opacity = 1,
  name,
  rotation,
  size,
  spin = false,
  style,
  className = "root",
}: IconProps) => {
  return (
    <StyledFontAwesomeIcon
      data-testid={`${name.iconName}-icon`}
      icon={name}
      onClick={onClick}
      size={size}
      spin={spin}
      sx={{
        cursor: onClick || clickable ? "pointer" : "inherit",
        color,
        opacity,
        transition: "transform 0.1s",
        transform: rotation ? `rotate(${rotation}deg)` : undefined,
        ...style,
      }}
      className={className}
    />
  );
};

export default Icon;
